import { jsxs as n, jsx as r } from "react/jsx-runtime";
import { Icon as u } from "../../icon/icon.js";
import { forwardRef as d } from "react";
import { Text as h } from "../../text/text.js";
import l from "clsx";
import { a as _ } from "../../../virginmediao2-momentum-icons-icons-fas-C-qJ8QLF.js";
import { s as o } from "../../../form-radio-group.module-m2XJo4vY.js";
const g = d(
  ({
    label: t,
    isFlag: a = !1,
    isSmall: e = !1,
    isBordered: s = !1,
    error: m = !1,
    isLabelFullWidth: f = !1,
    className: c,
    ...i
  }, p) => /* @__PURE__ */ n(
    "label",
    {
      "data-testid": "form-input-control",
      className: l(
        o["form-input-control"],
        {
          [o["form-input-control--is-flag"]]: !!a,
          [o["form-input-control--with-label"]]: !!t,
          [o["form-input-control--size-sm"]]: e,
          [o["form-input-control--is-bordered"]]: s,
          [o["form-input-control--is-invalid"]]: !!m,
          [o["form-input-control--is-label-full-width"]]: !!f
        },
        c
      ),
      children: [
        /* @__PURE__ */ n(
          "span",
          {
            "data-testid": "form-input-control-signifier",
            className: o["form-input-control__signifier"],
            children: [
              /* @__PURE__ */ r(
                "input",
                {
                  type: "radio",
                  name: i.name || t || "radio-input",
                  className: o["form-input-control__control"],
                  ...i,
                  ref: p
                }
              ),
              /* @__PURE__ */ r("span", { className: o["form-input-control__icon"], children: /* @__PURE__ */ r(u, { icon: _ }) })
            ]
          }
        ),
        /* @__PURE__ */ r(
          "span",
          {
            "data-testid": "form-input-label",
            className: l(o["form-input-control__label"], {
              [o["form-input-control__label--with-signifier"]]: !0
            }),
            children: /* @__PURE__ */ r(h, { size: "T300", weight: "regular", color: "default", children: t })
          }
        )
      ]
    }
  )
);
g.displayName = "FormRadioInput";
export {
  g as FormRadioInput,
  g as default
};
